import { AllPluginActions } from './plugin-registry';

export enum PluginEvents {
  // plugin communication
  PLUGIN_MESSAGE = 'plugin:message',
  PLUGIN_REQUEST = 'plugin:request',
  PLUGIN_RESPONSE = 'plugin:response'
}

export interface PluginMessagePayload<T = any> {
  from: string;
  to?: string;
  action: AllPluginActions;
  data?: T;
}

// type-safe payload definitions for each action
export interface ActionPayloads {
  // "Astimax" plugin - "Phone" module
  readonly 'astimax:phone:startCall': {
    targetNumber: string;
    withVideo?: boolean;
  };
  readonly 'astimax:phone:blindTransferCall': {
    targetNumber: string;
  };
  readonly 'astimax:phone:pickCall': {
    targetNumber: string;
  };
  
  // "X" plugin - "Y" module
  /*readonly 'x:y:doSomething': {
    param1: string;
    param2?: number;
  };*/
}

// helper type to get payload for a specific action
export type ActionPayload<T extends keyof ActionPayloads> = ActionPayloads[T];
